/**
 * モーダル
 */
import lenis from './lenis.js';

jQuery( function ($) {
  const body = $( 'body' );
  const focusTrap = $( '.js-focus-trap' )
  const closeButton = $( '.js-modal-close' );
  const modal = $( '.js-modal' );

  modal.on( 'wheel touchmove' ,(e) => {
    e.stopPropagation()
  });

	$( '.js-modal-button' ).on( 'click', function() {
		const modalId = $(this).data('modal-id');
    const modal = $( '#' + modalId );
    if ( modal.hasClass( 'is-active' ) ) {
      closeModal( modal );
    } else {
      openModal( modal );
    }
	} );

  closeButton.on( 'click', function() {
    const modal = $( this ).closest( '.js-modal' );
    closeModal( modal );
  } );

  const openModal = ( modal ) => {
    modal.fadeIn().addClass( 'is-active' ).focus();
    lenis.stop();
  }

  const closeModal = ( modal ) => {
    modal.fadeOut().removeClass( 'is-active' ).blur();
    lenis.start();
  }

  // フォーカストラップ制御
  focusTrap.on( 'focus', function() {
    $( this ).closest( '.js-modal' ).find( '.js-modal-close' ).focus();
  } );

} );